import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Capacitor } from "@capacitor/core";

/**
 * Handles Android hardware back button.
 * - On root pages: minimizes the app instead of closing
 * - On other pages: navigates back in history
 */
const ROOT_PATHS = ["/home", "/auth", "/"];

export const useNativeBackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let listener: any;

    const setup = async () => {
      const { App } = await import("@capacitor/app");

      listener = await App.addListener("backButton", ({ canGoBack }) => {
        const isRoot = ROOT_PATHS.includes(location.pathname);

        if (isRoot) {
          // Minimize app instead of closing
          App.minimizeApp();
        } else if (canGoBack) {
          navigate(-1);
        } else {
          navigate("/home");
        }
      });
    };

    setup();

    return () => {
      listener?.remove?.();
    };
  }, [navigate, location.pathname]);
};
